import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import logo from "../../assets/images/coat_of_arms.png"
import logoLight from "../../assets/images/coat_of_arms.png"
import logoLightSvg from "../../assets/images/coat_of_arms.png"
import logoDark from "../../assets/images/coat_of_arms.png"
import { withTranslation } from "react-i18next"
import { getUserRole, ROLE_LABELS } from "constants/roles"

const Header = props => {
  const navigate = useNavigate()
  const [isSearch, setSearch] = useState(false)
  const [searchParam, setSearchParam] = useState("")
  const [userRole, setUserRole] = useState(getUserRole())

  const handleSearch = () => {
    navigate(`/search/${encodeURIComponent(searchParam)}`)
  }
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="60" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="50" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="60" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="50" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu)
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            {userRole === "SUPER_ADMIN" && (
              <form className="app-search d-none d-lg-block">
                <div className="position-relative" style={{ display: "flex" }}>
                  <input
                    type="text"
                    className="form-control"
                    value={searchParam}
                    onChange={e => setSearchParam(e.target.value)}
                    placeholder="Search with REF ID or NIN..."
                  />
                  <span className="bx bx-search-alt" />
                  <button
                    className="btn btn-primary btn-rounded"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                </div>
              </form>
            )}
          </div>

          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.t("Search") + "..."}
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="d-inline-block ms-2 align-self-center">
              <span
                className="badge rounded-pill font-size-12 px-3 py-2"
                style={{
                  background: "rgba(255,255,255,0.15)",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.3)",
                  whiteSpace: "nowrap",
                }}
              >
                {ROLE_LABELS[userRole] || userRole}
              </span>
            </div>

            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout
  return { layoutType, showRightSidebar, leftMenu }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header))
